import request from 'utils/request';
import { keysToSnakeCase } from 'utils/stringUtils';

export default {
  getProcess: async (processId) => {
    return await request.get(`/processes/${processId}`);
  },

  listProcesses: async (groupId) => {
    return await request.get(`/suppliers/${groupId}/processes`);
  },

  createProcess: async (groupId, data) => {
    return await request.post(
      `/suppliers/${groupId}/processes`,
      keysToSnakeCase(data),
    );
  },

  updateProcess: async (processId, data) => {
    return await request.patch(
      `/processes/${processId}`,
      keysToSnakeCase(data),
    );
  },

  deleteProcess: async (processId) => {
    await request.delete(`/processes/${processId}`);
  },
};
